export const createPromotionSlice = (set, get) => ({
  // Applied promotions by id.
  appliedPromotions: [],

  // Add a promotion by ID, ensuring no duplicates.
  addPromotion: (promotionId) =>
    set((state) => {
      if (!state.appliedPromotions.includes(promotionId)) {
        return { appliedPromotions: [...state.appliedPromotions, promotionId] };
      }
      return state;
    }),
  // Remove a promotion by ID.
  removePromotion: (promotionId) =>
  set((state) => ({
    appliedPromotions: state.appliedPromotions.filter(id => id !== promotionId)
  })),

  // Clear all applied promotions.
  clearPromotions: () => set({ appliedPromotions: [] }),
  })
